import { SVGProps } from 'react'

export const GlobeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.99935 1.66675C12.0837 3.94871 13.2683 6.91011 13.3327 10.0001C13.2683 13.0901 12.0837 16.0515 9.99935 18.3334M9.99935 1.66675C7.91495 3.94871 6.73039 6.91011 6.66602 10.0001C6.73039 13.0901 7.91495 16.0515 9.99935 18.3334M9.99935 1.66675C5.39698 1.66675 1.66602 5.39771 1.66602 10.0001C1.66602 14.6025 5.39698 18.3334 9.99935 18.3334M9.99935 1.66675C14.6017 1.66675 18.3327 5.39771 18.3327 10.0001C18.3327 14.6025 14.6017 18.3334 9.99935 18.3334M2.0827 7.50008H17.916M2.08268 12.5001H17.916"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
